import { Card, CardContent, Grid2 } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useGetCareTeam } from '@hooks/api/care_team';
import { useListRelatedPersons } from '@hooks/api/related-person';

import { CareTeamCategory } from 'generated/types';

import ContactList from './ContactList';

const messages = defineMessages({
  careTeam: {
    id: 'clientProfileCard.careTeamContacts',
    defaultMessage: 'Care Team Contacts',
  },
  relatedPerson: {
    id: 'clientProfileCard.relatedPersonContacts',
    defaultMessage: 'Related Person Contacts',
  },
  medly: {
    id: 'clientProfileCard.contacts.medly',
    defaultMessage: 'Medly: {name}',
  },
  clinic: {
    id: 'clientProfileCard.contacts.clinic',
    defaultMessage: 'Clinic',
  },
});

export default function ContactsCard() {
  const { formatMessage } = useIntl();
  const { data: relatedPersonsData, loading: relatedPersonsLoading } =
    useListRelatedPersons();
  const {
    data: longitudinalCareTeamData,
    loading: longitudinalCareTeamLoading,
  } = useGetCareTeam();
  const { data: conditionCareTeamData, loading: conditionCareTeamLoading } =
    useGetCareTeam(CareTeamCategory.Condition);

  const longitudinalCareTeamParticipants =
    longitudinalCareTeamData?.participants ?? [];
  const conditionCareTeamParticipants =
    conditionCareTeamData?.participants?.map((p) => ({
      ...p,
      role_name: formatMessage(messages.medly, {
        name:
          p.resourceType === 'Organization'
            ? p.role_name || formatMessage(messages.clinic)
            : p.role_name,
      }),
    })) ?? [];

  const loading =
    relatedPersonsLoading ||
    longitudinalCareTeamLoading ||
    conditionCareTeamLoading;

  return (
    <Card>
      <CardContent>
        <Grid2 container rowGap={3} my={2}>
          <Grid2 size={{ xs: 12 }}>
            <ContactList
              loading={loading}
              relatedPersons={relatedPersonsData}
              title={formatMessage(messages.relatedPerson)}
              type="related-person"
            />
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <ContactList
              contacts={longitudinalCareTeamParticipants}
              loading={loading}
              organization_ids={
                longitudinalCareTeamData?.organization_ids ?? undefined
              }
              title={formatMessage(messages.careTeam)}
              type="care-team"
            />
          </Grid2>

          {conditionCareTeamParticipants.length > 0 && (
            <Grid2 size={{ xs: 12 }}>
              <ContactList
                contacts={conditionCareTeamParticipants}
                loading={conditionCareTeamLoading}
                organization_ids={
                  conditionCareTeamData?.organization_ids ?? undefined
                }
                read_only
                show_title={false}
                title={formatMessage(messages.careTeam)}
                type="care-team"
              />
            </Grid2>
          )}
        </Grid2>
      </CardContent>
    </Card>
  );
}
